import React, { useMemo } from "react";

const ProductFilter = ({
                           products,
                           selectedCategories = [],
                           selectedSubcategories = {},
                           selectedRegion = "",
                           onFilterChange,
                       }) => {
    const categories = useMemo(() => [...new Set(products.map(p => p.category))], [products]);
    const regions = useMemo(() => [...new Set(products.map(p => p.region.name))].sort(), [products]);
    const subcategoriesMap = useMemo(() => {
        const map = {};
        products.forEach(({ category, subcategory }) => {
            if (!subcategory) return;
            if (!map[category]) map[category] = new Set();
            map[category].add(subcategory);
        });
        Object.keys(map).forEach(key => {
            map[key] = Array.from(map[key]);
        });
        return map;
    }, [products]);

    const toggleCategory = (category) => {
        const updatedCategories = selectedCategories.includes(category)
            ? selectedCategories.filter(c => c !== category)
            : [...selectedCategories, category];

        const updatedSubcategories = { ...selectedSubcategories };
        if (!updatedCategories.includes(category)) {
            delete updatedSubcategories[category];
        }

        onFilterChange(updatedCategories, updatedSubcategories, selectedRegion);
    };

    const toggleSubcategory = (category, subcategory) => {
        const subs = selectedSubcategories[category] || [];
        const updatedSubs = subs.includes(subcategory)
            ? subs.filter(s => s !== subcategory)
            : [...subs, subcategory];

        onFilterChange(selectedCategories, { ...selectedSubcategories, [category]: updatedSubs }, selectedRegion);
    };

    const onRegionChange = (region) => {
        onFilterChange(selectedCategories, selectedSubcategories, region);
    };

    return (
        <>
            <button className="filter-toggle-btn" onClick={() => {
                const filterCard = document.getElementById("productFilterCard");
                if (filterCard) filterCard.classList.toggle("open");
            }}>
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div id="productFilterCard">
                <button className="close-btn" onClick={() => {
                    const filterCard = document.getElementById("productFilterCard");
                    if (filterCard) filterCard.classList.remove("open");
                }}>
                    ✕
                </button>

                <label><b>Регион:</b></label>
                <select
                    value={selectedRegion}
                    onChange={e => onRegionChange(e.target.value)}
                    style={{ width: "100%", marginBottom: 10 }}
                >
                    <option value="">Все регионы</option>
                    {regions.map(region => (
                        <option key={region} value={region}>{region}</option>
                    ))}
                </select>

                {categories.map(cat => (
                    <div key={cat} style={{ marginBottom: 10 }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={selectedCategories.includes(cat)}
                                onChange={() => toggleCategory(cat)}
                            />{" "}
                            <strong>{cat}</strong>
                        </label>

                        {selectedCategories.includes(cat) && subcategoriesMap[cat]?.length > 0 && (
                            <div style={{ paddingLeft: 20 }}>
                                {subcategoriesMap[cat].map(sub => (
                                    <label key={sub} style={{ display: "block" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedSubcategories[cat]?.includes(sub) || false}
                                            onChange={() => toggleSubcategory(cat, sub)}
                                        />{" "}
                                        {sub}
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default ProductFilter;
